import { render, staticRenderFns } from "./SplitTransloadTimeline.vue?vue&type=template&id=28a0bd9a"
import script from "./SplitTransloadTimeline.vue?vue&type=script&lang=js"
export * from "./SplitTransloadTimeline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports